import {
    ActivePreviewDesign,
    type PreviewThemes,
    type PreviewFonts,
    ActivePalletIndex,
    type PreviewInfo
} from 'types/preview';
import { previewThemes } from 'pages/Magic/Steps/constants';
import { createEvent, createStore } from 'effector';

// * events
const changeActiveDesign = createEvent<number>();
const changeThemes = createEvent<PreviewThemes>();
const changeDocumentFonts = createEvent<PreviewFonts>();
const changePalletIndex = createEvent<ActivePalletIndex>();
const resetCoverStyles = createEvent();

// * stores
const coverStyles = createStore<PreviewInfo>({
    documentFonts: {
        heading: '',
        body: ''
    },
    activeDesign: ActivePreviewDesign.First,
    palletIndex: ActivePalletIndex.First,
    themes: previewThemes
}).reset(resetCoverStyles);

coverStyles
    .on(changeThemes, (data: PreviewInfo, payload: PreviewThemes) => ({
        ...data,
        themes: payload
    }))
    .on(changePalletIndex, (data: PreviewInfo, payload: ActivePalletIndex) => ({
        ...data,
        palletIndex: payload
    }))
    .on(changeActiveDesign, (data: PreviewInfo, payload: ActivePreviewDesign) => ({
        ...data,
        activeDesign: payload
    }))
    .on(changeDocumentFonts, (data: PreviewInfo, payload: PreviewFonts) => ({
        ...data,
        documentFonts: payload
    }));

// * exports
export const designEvents = {
    changeDocumentFonts,
    changeActiveDesign,
    changePalletIndex,
    resetCoverStyles,
    changeThemes
};

export const designStores = {
    coverStyles
};
